<template>
  <div style="display: flex;" class="grow">
    <label class="chb-container">
      <input type="checkbox" v-model="isChecked" @change="selectionChanged(index)">
      <span class="checkmark"></span>
    </label>
  </div>

</template>
<script>
export default { 
  emits: ['change'],
  props: ["checked", "index"],
  watch: {
    checked(newVal, oldVal) {
      this.isChecked = newVal;
    }
  },
  data() {
    return {
      isChecked: this.checked
    };
  },
  methods: {
    selectionChanged(index) {
      this.$emit('change', index);
    }
  }
}
</script>

<style scoped>
.chb-container {
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.chb-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border-radius: 3px;   
  background-color: rgb(143, 209, 171);
}

/* On mouse-over, add a grey background color */
.chb-container:hover input ~ .checkmark {
  background-color: rgb(143, 209, 171);
}

/* When the checkbox is checked, add a blue background */
.chb-container input:checked ~ .checkmark {
  background-color: rgb(143, 209, 171);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.chb-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.chb-container .checkmark:after {
  left: 6px;
  top: 3px;
  width: 6px;
  height: 11px;
  border: solid black;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>


// WEBPACK FOOTER //
// src/components/CheckBox.vue